import React from "react";
import {
    IconSwapHorizontal,
    IconVehicleInMotion
} from "../../../../../../components/buttons/IconButtons";
import {MOVEMENT_DIRECTION_OPTIONS} from "../../../Model/Model";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @description
 * Renders the movement card of an entry and exit form: the selectable direction
 * options and, when the form type needs it, the complementary section received
 * as children.
 *
 * @param {Function} t - Translation function.
 * @param {string} idPrefix - Prefix of the ids of the direction options.
 * @param {Object} materialRequest - Current form information.
 * @param {Function} onSelectDirection - Handler called with the selected direction.
 * @param {boolean} emptyFields - Indicates whether the required fields must be highlighted.
 * @param {React.ReactNode} headerSection - Section the movement opens with, read before its direction.
 * @param {Array} options - Directions offered, so a form describes them with what it moves.
 * @param {React.ReactNode} children - Complementary section of the selected direction.
 */
const MovementDirectionSection = ({
    t,
    idPrefix,
    materialRequest,
    onSelectDirection,
    emptyFields,
    headerSection,
    options = MOVEMENT_DIRECTION_OPTIONS,
    children
}) => {

    return (
        <div className={'row border-radius-8px border-full-shades-300 mt-3'}>
            <div className={"d-flex p-2"}>
                <div className={"mr-2"}><IconVehicleInMotion/></div>
                <p className={"fs-14px ibl-font-w-600"}>{t("movement")}</p>
            </div>
            <div className={"border-bottom-shades-300 mb-3"}/>

            <div className={"col-12 mb-4"}>
                {headerSection}

                <div className={"d-flex mb-2"}>
                    <div className={"mr-2"}><IconSwapHorizontal/></div>
                    <p>{t("which_direction_is_this_movement_this_decides_the_steps_the_guard_will_perform_at_the_gate")} *</p>
                </div>
                <div className={"row mb-3"}>
                    { options.map(({ key, trans, description, Icon, iconBackground }) => {
                        const isSelected = materialRequest?.movementDirection === key;

                        return <div className={"col-sm-12 col-md-6 px-1"} key={key}>
                            <div
                                id={`div_${idPrefix}_movement_direction_${trans}`}
                                className={`p-3 d-flex border-radius-8px cursor-pointer ${isSelected
                                    ? 'background-primary-50 border-full-primary-500'
                                    : `background-shades-50 ${emptyFields && !materialRequest?.movementDirection
                                        ? 'border-full-error-code-600'
                                        : 'border-full-shades-100'}`}`}
                                onClick={() => onSelectDirection(key)}
                            >
                                <div className={`p-2 mr-3 border-radius-8px-0px ${iconBackground} d-flex align-items-center`}>
                                    <Icon width={24} height={24}/>
                                </div>
                                <div>
                                    <p className={"fs-14px ibl-font-w-600"}>
                                        {t(trans)}
                                    </p>
                                    <p className={"fs-14px"}>
                                        {t(description)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    })
                    }
                </div>

                {children}
            </div>
        </div>
    );
};

export default MovementDirectionSection;
